module.exports = __webpack_public_path__ + "static/media/about-3.e9d1ab0f.png";